import React from "react";
import T from "prop-types";
import { connect } from "react-redux";
import { Warning } from "MODULES/shared/components";
import { dollars } from "LIB/formatters/currency";
import { MINIMUM_EXCHANGE_SRP, SETTINGS } from "APP_ROOT/constants";

const MinimumSrpWarning = ({ minExchangeSrp, value }) => {
  const minimum = minExchangeSrp || 400;

  if (value && Number(value) < minimum) {
    return <Warning>Exchange SRP minimum is {dollars(minimum)}.</Warning>;
  }

  return null;
};

MinimumSrpWarning.propTypes = {
  minExchangeSrp: T.number,
  value: T.number
};

export default connect(state => ({
  minExchangeSrp: state.session.getIn([SETTINGS, MINIMUM_EXCHANGE_SRP])
}))(MinimumSrpWarning);



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/MinimumSrpWarning.jsx